import { useCallback, useEffect, useState } from "react";
import { getGinzaUniPoolApr } from "../utils/api/ginzaApi";

const useUniswapPoolApr = (uniPoolAddress: string) => {
  const [apr, setApr] = useState<number>(0);

  const getAllPoolApr = useCallback(async () => {
    setApr(0);
    const feeApr = await getGinzaUniPoolApr(uniPoolAddress);
    setApr(+feeApr);
  }, [uniPoolAddress]);

  useEffect(() => {
    getAllPoolApr();
  }, [getAllPoolApr]);

  return apr;
};

export default useUniswapPoolApr;
